import * as auth from "common/auth"

export const handleUnauthorizedApiResponseError = (err: any) => {
  if (err.status && (err.status === 401 || err.status === 403)) {
    auth.logout()
  }
}
